import { render, staticRenderFns } from "./ProcessCreatePage.vue?vue&type=template&id=4cd958b2"
import script from "./ProcessCreatePage.vue?vue&type=script&lang=js"
export * from "./ProcessCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports